export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[-+#?!@$%^&*=_()])[A-Za-z\d-+#?!@$%^&*=_()]{8,50}$/;
export const EXCLUDE_SPECIAL_CHARACTERS = /^[a-zA-Z0-9\s,'?"!();:_~`.。、「」『』（）─…﹏《》〈〉．]+$/;
export const ONLY_ALPHABETS = /^[a-zA-Z_]+$/;
export const VERSION_REGEX = /^[+]?(\d+(?:\.\d*)?|\.\d+)$/;
